<template>
  <div class="node-sequence">
    <svg class="node-sequence" width="2634px" height="1000px" pointer-events="none"
         position="absolute" version="1.1" xmlns="http://www.w3.org/2000/svg">

      <template v-for="(sequence, index) in getPath">
        <path
          :key="index"
          :d="sequence"
          transform="translate(10,4)" pointer-events="none" fill="none"
          stroke="#c2c3c4" stroke-width="1" stroke-dasharray="1,1"
          xmlns="http://www.w3.org/2000/svg" version="1.1"></path>
      </template>
    </svg>
  </div>
</template>
<script>
import Point from './point'

export default {
  props: ['nodes', 'connections', 'margin', 'rowWidth', 'rowHeight'],
  name: 'NodeSequence',
  data () {
    return {}
  },
  methods: {
    getCoords (node) {
      let elementPaddingX = this.rowWidth / 2
      let elementPaddingY = this.rowHeight / 2
      let wapperPaddingX = elementPaddingX + this.margin[0] / 2
      let wapperPaddingY = elementPaddingY + this.margin[1] / 2

      let x = node.position.x * (this.margin[0] + this.rowWidth) + this.rowWidth / 2 + this.margin[0]
      let y = (node.position.y) * (this.margin[1] + this.rowHeight) + this.rowHeight / 2 + this.margin[1]

      return {
        center: new Point(x, y),
        outers: [
          // right
          new Point(x + elementPaddingX, y),
          // bottom
          new Point(x, y + elementPaddingY),
          // left
          new Point(x - elementPaddingX, y),
          // top
          new Point(x, y - elementPaddingY)
        ],
        points: [
          // top-right
          new Point(x + wapperPaddingX, y - wapperPaddingY),
          // bottom-right
          new Point(x + wapperPaddingX, y + wapperPaddingY),
          // bottom-left
          new Point(x - wapperPaddingX, y + wapperPaddingY),
          // top-left
          new Point(x - wapperPaddingX, y - wapperPaddingY)
        ]
      }
    },

    getDirection (angle) {
      while (angle >= 180) {
        angle = angle - 360
      }

      if (angle > 90) {
        return 0
      } else if (angle >= 0) {
        return 1
      } else if (angle > -90) {
        return 2
      } else if (angle >= -180) {
        return 3
      }
    },

    inPath (coords, distance, targetNodeRow, sourceNodeRow, obstacleY, obstacleX) {
      let center = coords.center
      let outer = coords.outers[this.getDirection(distance.angle + 45)]
      let point = coords.points[this.getDirection(distance.angle)]
      // let path = `M${center.x} ${center.y} ` +
      let path = `M${outer.x} ${outer.y} ` +
          `l${!(center.y - outer.y) ? (point.x - outer.x) : 0} ${!(center.x - outer.x) ? (point.y - outer.y) : 0} `
      let height = this.rowHeight + this.margin[1]
      let range = 0
      // 处理直连的情况
      if ((Math.abs(distance.x) + Math.abs(distance.y)) !== 1) {
        if (!distance.x) {
          if (obstacleY.length) {
            if (obstacleY[0] > sourceNodeRow) {
              range = obstacleY[0] - sourceNodeRow - 1
            } else if (obstacleY[0] < sourceNodeRow) {
              range = obstacleY[obstacleY.length - 1] - sourceNodeRow + 1
            }
            height *= range
            path += `v${height} h0 l${point.x - center.x} 0 `
          }
        } else if (!distance.y) {
          if (obstacleX.length) {
            path += `v${height / 2} h0 `
          }
        } else {
          path += `l${(center.y - outer.y) ? (point.x - center.x) : 0} ${(center.x - outer.x) ? (point.y - center.y) : 0} `
        }
      }
      return path
    },

    onPath (distance, obstacleY, obstacleX, sourceNodeRow) {
      let width = this.rowWidth + this.margin[0]
      let height = this.rowHeight + this.margin[1]
      let centerLength = Number(obstacleY[obstacleY.length - 1]) - Number(obstacleY[0])
      if (!obstacleY.length) {
        if (distance.x > 0) {
          width *= distance.x - 1
        } else if (distance.x < 0) {
          width *= distance.x + 1
        } else {
          width = 0
        }

        if (distance.y > 0) {
          height *= distance.y - 1
        } else if (distance.y < 0) {
          height *= distance.y + 1
        } else {
          height = 0
        }

        return `v${height} h${width} `
      } else if (obstacleY.length) {
        if (obstacleY[0] > sourceNodeRow) {
          height *= centerLength + 1
          return `v${height} h0 `
        } else if (obstacleY[0] < sourceNodeRow) {
          height *= -centerLength - 1
          return `v${height} h0 `
        }
      } else if (obstacleX.length) {
        width *= centerLength + 1
        return `v0 h${width} `
      }
    },

    outPath (coords, distance, targetNodeRow, sourceNodeRow, obstacleY, obstacleX) {
      let center = coords.center
      let position = this.getDirection(distance.angle + 45 + 180)
      let pointPosition = this.getDirection(distance.angle + 180)

      if (distance.angle % 90 === 0) {
        pointPosition = (pointPosition + 2) % 4
      }

      let outer = coords.outers[position]
      let point = coords.points[pointPosition]

      let path = ''
      let height = this.rowHeight + this.margin[1]
      let range = 0
      // 处理直连的情况
      if ((Math.abs(distance.y) + Math.abs(distance.x)) !== 1) {
        // 垂直在一行
        if (!Math.abs(distance.x)) {
          if (obstacleY.length) {
            if (obstacleY[0] > sourceNodeRow) {
              range = targetNodeRow - obstacleY[obstacleY.length - 1] - 1
            } else if (obstacleY[0] < sourceNodeRow) {
              range = targetNodeRow - obstacleY[0] + 1
            }
            height *= range
            path += ` l${center.x - point.x} 0 v${height} `
          }
        } else if (!Math.abs(distance.y)) {
          if (obstacleX.length) {
            path += `0 v${-height * 1 / 2} `
          }
        } else {
          path += `l${!(center.x - outer.x) ? (outer.x - point.x) : 0} ${!(center.y - outer.y) ? (outer.y - point.y) : 0} `
        }
      }

      if (position === 0) {
        path += 'h-10 l2 -4 l-4 4 l4 4 l-4 -4'
      } else if (position === 1) {
        path += 'v-10 l4 2 l-4 -4 l-4 4 l4 -2'
      } else if (position === 2) {
        path += 'h10 l-2 4 l4 -4 l-4 -4 l2 4'
      } else if (position === 3) {
        path += 'v10 l-4 -2 l4 4 l4 -4 l-4 2'
      }

      return path
    }
  },
  computed: {
    getPath () {
      let path = []
      this.connections.forEach(m => {
        let sourceNode = this.nodes.find(n => n.id === m.sourceNodeId)
        let targetNode = this.nodes.find(n => n.id === m.targetNodeId)
        if (sourceNode && targetNode) {
          let sourceCoords = this.getCoords(sourceNode)
          let targetCoords = this.getCoords(targetNode)

          let obstacleY = []
          let obstacleX = []

          let distance = {
            x: targetNode.position.x - sourceNode.position.x,
            y: targetNode.position.y - sourceNode.position.y
          }

          // 计算角度
          distance.angle = 180 / Math.PI * Math.atan2(distance.x, distance.y)
          // 判断障碍物
          if (sourceNode.position.x === targetNode.position.x || sourceNode.position.y === targetNode.position.y) {
            this.nodes.forEach((item) => {
              if (item.position.x !== 0) {
                if (distance.y === 0) {
                  // 水平方向方向出现障碍物
                  if (item.position.y === targetNode.position.y &&
                      item.position.x > Math.min(sourceNode.position.x, targetNode.position.x) &&
                      item.position.x < Math.max(sourceNode.position.x, targetNode.position.x)) {
                    obstacleX.push(item.position.x)
                  }
                } else if (distance.x === 0) {
                  // 垂直方向出现障碍物
                  if (item.position.x === targetNode.position.x &&
                      item.position.y > Math.min(sourceNode.position.y, targetNode.position.y) &&
                      item.position.y < Math.max(sourceNode.position.y, targetNode.position.y)) {
                    obstacleY.push(item.position.y)
                  }
                }
              }
            })
          }

          path.push(
            this.inPath(sourceCoords, distance, targetNode.position.y, sourceNode.position.y, obstacleY, obstacleX) +
              this.onPath(distance, obstacleY, obstacleX, sourceNode.position.y) +
              this.outPath(targetCoords, distance, targetNode.position.y, sourceNode.position.y, obstacleY, obstacleX)
          )
        }
      })
      return path
    }
  }
}
</script>
<style lang="scss">
  .node-sequence {
    > svg {
      z-index: 1
    }
    width: 2634px;
    position: absolute;
    left: 50%;
    margin-left: -1315px;
    height: 160%;
  }
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-node-sequence.vue